// angular
import { Component } from '@angular/core';
// other libraries
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-messages-skeleton',
  standalone: true,
  imports: [
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './messages-skeleton.component.html',
  styleUrl: './messages-skeleton.component.scss'
})
export class MessagesSkeletonComponent {

}
